import { AfterViewInit, Component, ElementRef, Input, OnChanges, booleanAttribute, inject, viewChild } from '@angular/core';
import { HorizonRatingsUtilsService, RatingsCategoryRanks } from '../horizon-ratings-utils';

@Component({
    selector: 'topo-ratings-bar',
    templateUrl: './ratings-bar.component.html',
    styleUrls: ['./ratings-bar.component.scss'],
    standalone: false
})
export class RatingsBarComponent implements OnChanges, AfterViewInit {
  @Input() value: number = 0;
  @Input() label: string;
  @Input() categoryRank: RatingsCategoryRanks;

  @Input({ transform: booleanAttribute }) tiny: boolean;
  @Input({ transform: booleanAttribute }) small: boolean;
  @Input({ transform: booleanAttribute }) large: boolean;

  @Input({ transform: booleanAttribute }) largeLabel: boolean;

  @Input({ transform: booleanAttribute }) horizontal: boolean;
  @Input() horizontalBarWidth: string = '130px';

  private ratingsUtils = inject(HorizonRatingsUtilsService);
  protected max = this.ratingsUtils.maxRatingValue;

  protected progressBarClass: string;
  protected progressBarColor: string;
  private progressElRef = viewChild<ElementRef<HTMLProgressElement>>('progressBar');

  ngAfterViewInit(): void {
    this.setProgressElementColor();
  }

  ngOnChanges(): void {
    this.setComponentProperties();
    this.setProgressElementColor();
  }

  private setComponentProperties(): void {
    const { text, color } = this.ratingsUtils.getRatingsTextAndColor(this.value);

    if (!Boolean(this.label)) {
      this.label = text;
    }

    const sizeClass = this.large ? 'is-large' : this.small ? 'is-small' : this.tiny ? 'is-tiny' : '';

    this.progressBarClass = sizeClass;
    this.progressBarColor = color;
  }

  private setProgressElementColor(): void {
    this.progressElRef()?.nativeElement?.style.setProperty('--rating-color', this.progressBarColor);
  }
}
